// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1mSyZ","consentsList":"PatientConsents_consentsList__2mRy4","consentsListEmpty":"PatientConsents_consentsListEmpty__hu_E-"};